
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M12 2a5.506 5.506 0 00-5.5 5.5.5.5 0 00.5.5h10a.5.5 0 00.5-.5C17.5 4.469 15.033 2 12 2zM7.528 7c.25-2.246 2.16-4 4.472-4a4.506 4.506 0 014.472 4H7.528zM17 9H7a.5.5 0 00-.5.5v8c0 1.208.86 2.218 2 2.45v2.55c0 .827.673 1.5 1.5 1.5s1.5-.673 1.5-1.5V20h1v2.5c0 .827.673 1.5 1.5 1.5s1.5-.673 1.5-1.5v-2.55c1.14-.233 2-1.242 2-2.45v-8A.5.5 0 0017 9zm-.5 8.5c0 .827-.673 1.5-1.5 1.5a.5.5 0 00-.5.5v3a.5.5 0 01-1 0v-3a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5v3a.5.5 0 01-1 0v-3A.5.5 0 009 19c-.827 0-1.5-.673-1.5-1.5V10h9v7.5z","fill":"#00003C"}}),_c('path',{staticClass:"active-highlight",attrs:{"d":"M10 6a.5.5 0 100-1 .5.5 0 000 1zM14 6a.5.5 0 100-1 .5.5 0 000 1z","fill":"#E2E4EC"}}),_c('path',{attrs:{"d":"M20 9c-.827 0-1.5.674-1.5 1.5v5c0 .827.673 1.5 1.5 1.5s1.5-.673 1.5-1.5v-5c0-.826-.673-1.5-1.5-1.5zm.5 6.5a.5.5 0 01-1 0v-5a.5.5 0 011 0v5zM4 9c-.827 0-1.5.674-1.5 1.5v5c0 .827.673 1.5 1.5 1.5s1.5-.673 1.5-1.5v-5C5.5 9.675 4.827 9 4 9zm.5 6.5a.5.5 0 01-1 0v-5a.5.5 0 011 0v5zM10.49 2.707L9.46.304a.5.5 0 00-.919.394l1.03 2.403a.5.5 0 10.918-.394zM15.196.041a.5.5 0 00-.656.263l-1.03 2.403a.5.5 0 10.92.394L15.459.697a.5.5 0 00-.263-.656z","fill":"#00003C"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"#fff"}})])])])
          )
        }
      }
    